/**
    商品列表
**/
<template>
  <div class="rightaside_content">
  <h3 class="headerTitle">文章列表</h3>
  <el-divider></el-divider>
        <el-row :gutter="20"  v-loading='loading'> 
            <el-col v-for="item in articleList" :key="item.id">
                <div class="articleItem">
                    <el-row style="width: 100%;" :gutter="20">
                        <el-col :span="6">
                            <el-image :src="item.articleImage">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>  
                        </el-col>
                        <el-col :span="18">
                            <!-- <div> -->
                                <div class="title OneLineDisplay">{{item.articleTitle}}</div>
                                <div class="descript">
                                    <span><i class="el-icon-user-solid"></i> {{item.createBy}}</span>
                                    <span><i class="el-icon-folder"></i> {{item.name}}</span>
                                    <span><i class="el-icon-chat-round"></i> {{item.articleCount}}</span>
                                    <span><i class="el-icon-date"></i> {{item.createTime}}</span>
                                </div>
                                <!-- <div class="content OneLineDisplay" v-html="item.articleContent"></div> -->
                                <router-link :to='`/siteHelpDetail?itemId=${item.articleId}`' class="seeMore"><span>查看更多</span></router-link>
                            <!-- </div> -->
                        </el-col>
                    </el-row>                                  
                    
                </div>
                <el-divider></el-divider>
            </el-col>
            <el-col class="noData"  v-if="articleList.length==0?true:false">
                <div>暂无相关文章</div>
            </el-col>

        <el-col :span="24" class="pagination">
                <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </el-col>
        </el-row> 
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import {helpArticle_list} from '@/api/xunyou'
export default {
  data() {
    return {
        loading:false,
        articleList: [],
     // 请求数据参数
        formInline: {
            pageSize: 10,
            pageNum: 1,
            categoryId:this.$route.query.categoryId || ''
        },
        // 分页参数
        pageparm:{
            pageSize:10,
            currentPage:1,
            total:0,
        },
    };
  },
    // 注册组件
  components: {Pagination},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
      this.getHelpArticle_list()
  },

watch:{

    $route(n,o){
        if(n.fullPath !== o.fullPath){ //监听路由参数是否变化
           this.getHelpArticle_list()  //methods中封装的加载数据函数
        }
    }

},
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
       // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getHelpArticle_list()
    },
    // 文章（和公告）列表接口   
        getHelpArticle_list(){
            this.loading =true
            this.formInline.categoryId=this.$route.query.categoryId || ''
            helpArticle_list(this.formInline)
                .then(res => {
                if (res.code == 0) {
                    console.log(res)
                    this.loading = false
                    this.articleList = res.rows;
                    this.pageparm.currentPage = this.formInline.pageNum
                    this.pageparm.pageSize = this.formInline.pageSize
                    this.pageparm.total = res.total
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.loading = false
                this.$message.error('获取文章列表失败，请稍后再试！')
                })
        },
    //    //  个人信息加密
    // encryption(str, len) {
    //   if (str.length <= len) {
    //     return str;
    //   } else {
    //     var newStr = str.substring(0, 1);
    //     var newStrs = str.substring(str.length - 1, str.length - 2);
    //     newStr = newStr + "***" + newStrs;
    //     return newStr;
    //   }
    // },
  },
};
</script>

<style scoped lang="less">
.noData{
        text-align: center;
        height: 200px;
        line-height: 200px;
    }
.rightaside_content {
    // padding: 30px 0;
    // box-sizing: border-box;
    .headerTitle {
        font-size: 20px;
        height: 40px;
        line-height: 40px;
        color: #666;
    }
    i.pointNum {
        font-size: 42px;
        font-weight: 600;
    }
    .articleItem{
        display: flex;
        justify-content: start;
        .el-image {
            width: 180px;
            height: 150px;
            margin-right: 30px;
            background: #e8e8e8;
            /deep/.image-slot {
                line-height: 150px;
                text-align: center;
            }
        }
        .title {
            font-size: 18px;
            color: #666;
            margin-bottom: 5px;
        }
        .descript {
            padding: 0px 0 10px 0;
            color: #666;
            font-size: 14px;
            span{
                margin-right: 5px;
            }
        }
        .content {
            font-size: 14px;
            margin-bottom: 10px;
            height: 25px;

        }
        a.seeMore {
            border: 1px solid #eaeaea;
            padding: 10px 12px;
            background: #eee;
            display: inline-block;
        }
        a.seeMore:hover{
            background: #ff6700;
            border: 1px solid #ff6700;
            color: white;
        }
    }
    .pagination{
        text-align: right;
        /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #ff6700;
            color: #FFF;
            width: 20px;
        }
        /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
            width: 20px;
        }
        /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
            background-color: transparent;
        }
        }    
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/serviceArticle/siteHelp.vue